import { VStack } from "@chakra-ui/react";
import { PopulatedWallet } from "@syla/shared/types/models/WalletBase";
import React, { useContext } from "react";
import { EmptyDataMessage } from "../../../atoms/EmptyDataMessage";
import { LoadingIndicator } from "../../../molecules/LoadingIndicator";
import { DataSourceLoadingContext } from "./MainDataSourceTable";

import { MainDataSourceTableRow } from "./MainDataSourceTableRow";

interface RenderWalletsProps {
  walletResponses: PopulatedWallet[];
}

export const RenderWallets = ({
  walletResponses,
}: RenderWalletsProps): React.ReactElement => {
  const { isLoading } = useContext(DataSourceLoadingContext);

  if (isLoading) {
    return <LoadingIndicator content="Loading Data Sources" />;
  }

  if (walletResponses.length) {
    return (
      <VStack h="full" w="full" spacing={3}>
        {walletResponses.map((walletResponse) => (
          <MainDataSourceTableRow
            key={walletResponse._id}
            walletResponse={walletResponse}
          />
        ))}
      </VStack>
    );
  }
  return (
    <VStack w="full" justifyContent="center">
      <EmptyDataMessage content="Add a data source to make the most of your Syla account" />
    </VStack>
  );
};
